import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowNeutral = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 6,
	viewBox: "0 0 14 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 2.5C0.723858 2.5 0.5 2.72386 0.5 3C0.5 3.27614 0.723858 3.5 1 3.5L1 2.5ZM14 3L9 0.113249V5.88675L14 3ZM1 3L1 3.5L9.5 3.5V3V2.5L1 2.5L1 3Z",
		fill: "#50566E"
	})
});
export default SvgArrowNeutral;
